import { createSelector } from 'reselect'

import { initialState } from '../reducers/configurationReducer'

const stateSelector = (state) => state.configuration || initialState

// Async state selectors
export const fetchingSelector = createSelector(stateSelector, (state) => state.fetching)
export const fetchedSelector = createSelector(stateSelector, (state) => state.fetched)
export const errorSelector = createSelector(stateSelector, (state) => state.error)

// Config selectors
export const elasticSelector = createSelector(stateSelector, (state) => state.elastic)
export const contentGraphSelector = createSelector(stateSelector, (state) => state.contentGraph)
export const redisSelector = createSelector(stateSelector, (state) => state.redis)
export const indexerQueueSelector = createSelector(stateSelector, (state) => state.indexerQueue)
export const s3BucketSelector = createSelector(stateSelector, (state) => state.s3Bucket)
export const seleneSelector = createSelector(stateSelector, (state) => state.selene)
